import files from 'file-saver'
import api from '@/api'
import {getHeaderName} from '@/utils'
import {
  SET_EXPORTING,
  SET_DEPENDENCY_ALL_DEPENDENCE,
  SET_DEPENDENCY_NAME_VERSION_MAP,
} from './mutation-types'

const state = {
  exporting: {
    1: false,
    2: false,
  },
  allDependence: [],
  dependenceNameVersionMap: {},
}

const mutations = {
  [SET_EXPORTING] (state, payload) {
    state.exporting[payload.type] = payload.status
  },
  [SET_DEPENDENCY_ALL_DEPENDENCE] (state, allDependence) {
    state.allDependence = allDependence
  },
  [SET_DEPENDENCY_NAME_VERSION_MAP] (state, map) {
    state.dependenceNameVersionMap = map
  },
}

const getters = {
  // 获取所有 dependenceName（去重）
  allDependenceNames (state) {
    return Object.keys(state.dependenceNameVersionMap)
  },
}

const actions = {
  // 获取所有依赖信息
  async setDependency ({commit, state}, payload) {
    const {data, code} = await api.deployApi.getCgDependenceList({})
    if (code === 200 && data) {
      // 创建 dependenceName 到 dependenceVersion 的映射（一对多）
      const nameVersionMap = {}
      data.forEach(item => {
        const { dependenceName, dependenceVersion } = item
        if (!nameVersionMap[dependenceName]) {
          nameVersionMap[dependenceName] = []
        }
        // 避免重复的版本
        if (!nameVersionMap[dependenceName].includes(dependenceVersion)) {
          nameVersionMap[dependenceName].push(dependenceVersion)
        }
      })

      // 存储 allDependence 和映射到 state
      commit(SET_DEPENDENCY_ALL_DEPENDENCE, data)
      commit(SET_DEPENDENCY_NAME_VERSION_MAP, nameVersionMap)
    }
    return data
  },
  // 根据 dependenceName 获取 dependenceVersion 数组
  getDependenceVersionsByName ({state}, dependenceName) {
    return state.dependenceNameVersionMap[dependenceName] || []
  },
  // 根据 dependenceName 和 dependenceVersion 获取 dependenceId
  getDependenceIdByNameAndVersion ({state}, { dependenceName, dependenceVersion }) {
    const matched = state.allDependence.find(
      item => item.dependenceName === dependenceName && item.dependenceVersion === dependenceVersion
    )
    return matched ? matched.id : null
  },
  // 获取依赖列表
  async getDependencyList ({commit, state}, payload) {
    const {data} = await api.deployApi.getCgDependenceList(payload)
    return data
  },
  // 获取依赖配置列表
  async getDependencyConfigList({commit, state}, payload) {
    const {data} = await api.deployApi.getPluginConfigList(payload)
    return data
  },
  async importExcelDependency ({state}, payload) {
    const data = await api.deployApi.importExcelPlugin(payload)
    return data
  },
  async exportDependencyTemplateExcel ({commit, state}) {
    try {
      commit(SET_EXPORTING, {type: 1, status: true})
      const {data, headers} = await api.deployApi.exportPluginTemplateExcel()
      commit(SET_EXPORTING, {type: 1, status: false})
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/octet-stream' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_EXPORTING, {type: 1, status: false})
    }
  },
  async exportDependencyDateExcel ({commit, state}, payload) {
    try {
      commit(SET_EXPORTING, {type: 2, status: true})
      const {data, headers} = await api.deployApi.exportPluginDataExcel(payload)
      commit(SET_EXPORTING, {type: 2, status: false})
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/octet-stream' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_EXPORTING, {type: 2, status: false})
    }
  },
  async addDependencyConfig ({state}, payload) {
    const data = await api.deployApi.addPluginConfig(payload)
    return data
  },
  async deleteDependencyConfig ({state}, payload) {
    const data = await api.deployApi.deletePluginConfig(payload)
    return data
  },
  async addDependency ({state}, payload) {
    const data = await api.deployApi.addDependency(payload)
    return data
  },
  async dealDependency ({state}, payload) {
    const data = await api.deployApi.dealPlugin(payload)
    return data
  },
  async deleteDependency ({state}, payload) {
    const data = await api.deployApi.deleteCgDependence(payload)
    return data
  },
  async dependencyAllocatePlatform ({state}, payload) {
    const {code} = await api.deployApi.pluginAllocatePlatform(payload)
    return code
  },
  async dependencyAllocateOS ({state}, payload) {
    const {code} = await api.deployApi.pluginAllocateOS(payload)
    return code
  },
  async allocateCV ({state}, payload) {
    const {code} = await api.deployApi.allocateCV(payload)
    return code
  },
  async modifyOpenStatus ({state}, payload) {
    const {code} = await api.deployApi.modifyOpenStatus(payload)
    return code
  },
  async getCgDependencyControlPullSelect ({state}, payload) {
    const {data} = await api.deployApi.getCgPluginControlPullSelect(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
